import { FormikProps } from "formik";
import { TextInputFormik } from "../../../../formcontrols/InputItem";
import { OpretFirmaStep2Formik } from "../../opretFirmaInterface";

const OpretFirmaKontaktoplysninger = ({
  formik,
}: {
  formik: FormikProps<OpretFirmaStep2Formik>;
}) => {
  return (
    <>
      <h3 className="mb-n2 flex-100">Kontaktoplysninger</h3>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "email",
            initialValue: "",
            label: "E-mail",
          }}
          formik={formik}
        />
      </div>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "emailNotification",
            initialValue: "",
            label: "E-mail, Domstolsstyrelsen-notifikation",
          }}
          formik={formik}
        />
      </div>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "phone",
            initialValue: "",
            label: "Telefon",
          }}
          formik={formik}
        />
      </div>
      <div>
        <TextInputFormik
          config={{
            component: "textinput",
            id: "website",
            initialValue: "",
            label: "Hjemmeside",
          }}
          formik={formik}
        />
      </div>
    </>
  );
};

export default OpretFirmaKontaktoplysninger;
